import * as Yup from "yup";

const CompanyPositionSchema = Yup.object().shape({

  positionName: Yup.string().required("Please enter your position name (TH)."),

  positionNameEn: Yup.string().required(
    "Please enter your position name (EN)."
  ),
  under: Yup.string().when("level", {
    is: (val) => val != 1,
    then: () => Yup.string().required('Please select your under'),
    otherwise: () => Yup.string().notRequired(),
  }),

});

export default CompanyPositionSchema;
